import { render } from "./ProjectReportIndex.vue?vue&type=template&id=379a099e"
import script from "./ProjectReportIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectReportIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Reports/ProjectReportIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "379a099e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('379a099e', __exports__)) {
    api.reload('379a099e', __exports__)
  }
  
  module.hot.accept("./ProjectReportIndex.vue?vue&type=template&id=379a099e", () => {
    api.rerender('379a099e', render)
  })

}


export default __exports__